import Vue from 'vue';
import Vuetify from 'vuetify';
import '@/sass/overrides.sass';

Vue.use(Vuetify);

const app = {
  primary: '#BBB',
  accent: '#8dc63f',
  secondary: '#444',
  success: '#71BC78',
  info: '#364150',
  warning: '#E69138',
  error: '#C01212',
};

export default new Vuetify({
  theme: {
    themes: {
      dark: app,
      light: app,
    },
  },
});
